import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/inbox/')({
  component: () => <div>Hello /_authenticated/inbox/!</div>,
})
